module.exports = __webpack_public_path__ + "static/video@2x-8a635ddcc5e6c1ddc6a2c88edcb5fa4a.png";